module.exports = __webpack_public_path__ + "img/dialog.c521528f.svg";